<script> 
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import { dadosUsuarioLS } from '../../utils';

	let resultadoBusca = [];
	let dadosUsuario;

	dadosUsuario = dadosUsuarioLS();
	let { json: { dados } } = JSON.parse(localStorage.getItem('AVAL_LISTAGEM_USUARIOS_CACHE_PG9999'));
	resultadoBusca = dados;

	const esconderPartesCPF = (cpf) => cpf.replace(/\d(?<=\d{4})\d(?=\d{2})/g, "##");
</script>

<style>
.container_tabela {
	overflow-x: auto;
}
</style>

<TBoxInterno 
	titulo="Resultado da Busca" 
	subtitulo="..."
	largura="10" 
	icone="buscar"
	deslocamento="1">

	<div class="container_tabela">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>#</th>
					<th>CPF</th>
					<th>Nome</th>
					<th>E-mail</th>
					<th>Perfis</th>
					<th>Unidade</th>
				</tr>
			</thead>
			<tbody>
				{#each resultadoBusca as valor, i}
				<tr>
					<th>{ ++i }</th> 
					<td><a href="#/usuario/visualizar/{valor.cpf}">{ esconderPartesCPF(valor.cpf) }</a></td>
					<td>{ valor.nome }</td>
					<td>{ valor.email }</td>
					<td>{ valor.perfis }</td>
					<td>{ valor.unidade }</td>
				</tr>
				{/each}
			</tbody>
		</table>
	</div>
</TBoxInterno>